import { useState } from "react";

export default function useLoader() {
  const [count, setCount] = useState(0);

  const start = () => setCount((c) => c + 1);
  const stop = () => setCount((c) => Math.max(c - 1, 0));

  return {
    loading: count > 0,
    start,
    stop,
  };
}
